import { gql } from '@apollo/client/core'
import { BlobUpload } from '@rails/activestorage/src/blob_upload'
import { FileChecksum } from '@rails/activestorage/src/file_checksum'

/**
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */
export default async ({ app }) => {
  const apollo = app.apolloProvider.defaultClient

  function calculateChecksum (file) {
    return new Promise((resolve, reject) => {
      FileChecksum.create(file, (error, checksum) => {
        if (error) {
          reject(error)
          return
        }

        resolve(checksum)
      })
    })
  }

  const createDirectUpload = async function (metadata) {
    const mutation = gql`mutation ($input: CreateDirectUploadInput!){
      createDirectUpload(input: $input) {
        directUpload {
          url
          headers
          blobId
          signedBlobId
        }
        errors {
          code
          description
        }
      }
    }`

    const { filename, contentType, byteSize, checksum, isPublic } = metadata

    const result = await apollo.mutate({
      mutation,
      variables: {
        input: {
          directUploadInput: {
            filename,
            contentType,
            byteSize,
            checksum,
            isPublic
          }
        }
      }
    })

    return result.data.createDirectUpload.directUpload
  }

  const blobUpload = async function (file, directUpload) {
    const { url, headers } = directUpload

    const upload = new BlobUpload({ file, directUploadData: { url, headers: JSON.parse(headers) } })
    return new Promise((resolve, reject) => {
      upload.create(error => {
        if (error) {
          reject(error)
        } else {
          resolve()
        }
      })
    })
  }

  const uploadFile = async function (file, isPublic = false) {
    const checksum = await calculateChecksum(file)
    const metadata = {
      checksum,
      filename: file.name,
      contentType: file.type,
      byteSize: file.size,
      isPublic
    }

    const directUpload = await createDirectUpload(metadata)

    await blobUpload(file, directUpload)

    const key = new URL(directUpload.url).pathname.substr(1)

    return { blobId: directUpload.blobId, key }
  }

  const dataUrlToFile = function (dataurl, filename) {
    const arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
  }

  const directUpload = { uploadFile, dataUrlToFile }

  app.config.globalProperties.$directUpload = directUpload
}
